/**@description all the http headers used by our interceptors in one spot.  */
export enum EInterceptorOptionsHTTPHeaders {
    /**@description Stop the loading pinwheel from displaying for this request */
    SuppressLoadingInterceptor = "Suppress-Loading-Interceptor",
    /** @description Stops the error interceptor from displaying. Useful for situations when an error code can expected in normal situations. */
    SuppressErrorInterceptor = "Supress-Error-Display",
    /** @description Stops the "saved" pop up */
    ShowSavedNotification = "Show-Saved-Notification",
    SupressSavedInterceptor = "Supress-Saved-Notification"
}